import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, pipe } from 'rxjs';
import { HttpClient } from "@angular/common/http";
import { LgvSettings } from '../../data-models/lgv-settings.model';
import { environment } from '../../../environments/environment';
import { LgvAPIService } from '../services/lgv-api.service';
import { filter, map } from 'rxjs/operators';
import { LgvCompanyService } from './lgv-company.service';


@Injectable({
    providedIn: 'root'
})
export class LgvSettingsService  {

    private model$ = new BehaviorSubject<LgvSettings>(null);
    public LgvSettings$: Observable<LgvSettings>;

    _ShowCoBranding: boolean = null;
    ShowCoBranding$ = new BehaviorSubject(this._ShowCoBranding);


    get IsRealtor$(): Observable<boolean> {
        return this.LgvSettings$.pipe(
            map(obj =>
                obj.businessType ==='realtor'));
    }

    get Theme$(): Observable<string>{
        return this.LgvSettings$.pipe(
            map(obj =>
                obj.theme));
    }

    StoragePrefix = 'LGV_Settings_';


    constructor(private http: HttpClient,
        private lgvCompanySvc: LgvCompanyService,
        private LGS: LgvAPIService)
    {
        this.ShowCoBranding$.next(false);

        this.lgvCompanySvc.activeCompany$.pipe(filter(f=> f!== null)).subscribe(x => {
            //console.log(`XXXXX Settings Service - lgvCompanySvc.activeCompany XXXXX`);
            //console.log(x);

            let newObj = new LgvSettings();

            let savedTheme = localStorage.getItem(this.StoragePrefix + 'theme');
            newObj.theme = savedTheme ? savedTheme : LgvSettings.AvailableThemes()[0].value;

            let savedBT = localStorage.getItem(this.StoragePrefix + 'businessType');
            newObj.businessType = savedBT ? savedBT : LgvSettings.SupportedBusinessTypes()[0].value;

            newObj.selectedCompany = x.companyCode;

            this.model$.next(newObj);
            this.LgvSettings$ = this.model$;
        })


    }

    GetLgvSettingsAsObject(): LgvSettings { return this.model$.value; }

    SetTheme(theme: string) {
        let lgvSettings = this.model$.value;
        lgvSettings.theme = theme.toLocaleLowerCase();
        this.model$.next(lgvSettings);
        localStorage.setItem(this.StoragePrefix + 'theme', lgvSettings.theme);
    }

    SetBusinessType(bt: string) {
        let lgvSettings = this.model$.value;
        lgvSettings.businessType = bt.toLocaleLowerCase();
        this.model$.next(lgvSettings);
        localStorage.setItem(this.StoragePrefix + 'businessType', lgvSettings.businessType);
    }

    SetShowCoBranding(bool: boolean) {
        this.ShowCoBranding$.next(bool);
    }


    SetShowRefinanceOptions(bool: boolean) {
        let lgvSettings = this.model$.value;
        lgvSettings.showRefinanceOptions = bool;
        this.model$.next(lgvSettings);
    }

    SetShowRealEstateOptions(bool: boolean) {
        let lgvSettings = this.model$.value;
        lgvSettings.showRealEstateOptions = bool;
        this.model$.next(lgvSettings);
    }

    ClearSettings() {
        this.model$.next(new LgvSettings());
    }

}
